<template>
  <v-dialog :value="showLanguages" width="500" hide-overlay @input="setShowLanguages">
    <v-card>
      <v-card-title>
        {{ $t('Global.App.lang') }}
      </v-card-title>
      <v-card-text class="py-5">
        <v-row class="text-center">
          <v-col v-for="lang in langs" :key="lang.value">
            <v-btn @click="$i18n.locale = lang.value" :color="$i18n.locale === lang.value ? 'primary' : 'black'" :outlined="$i18n.locale !== lang.value">
              <v-icon left>language</v-icon>
              {{lang.text}}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="setShowLanguages(false)">{{ $t('Global.Action.close') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
export default {
  name: 'LocaleSelector',
  data: () => ({
    langs: [{text: 'Français', value: 'fr'}, {text: 'English', value: 'en'}]
  }),
  computed: {
    ...mapState('lang', [
      'showLanguages'
    ])
  },
  watch: {
    '$i18n.locale' (newValue) {
      this.$vuetify.lang.current = newValue
    }
  },
  methods: {
    ...mapMutations('lang', [
      'setShowLanguages'
    ])
  }
}
</script>